import {
  FIT_GUIDE_BRAND_IDS,
  FIT_GUIDE_PRODUCT_TYPE_IDS,
  FIT_GUIDE_GENDERS,
} from "../constants";

export const fitTypeIdToTranslationKey: Record<number, string> = {
  53000: "fit_guide_muscle_fit",
  61452: "fit_guide_slim_fit",
  53002: "fit_guide_regular_fit",
  53003: "fit_guide_relaxed_fit",
  53001: "fit_guide_oversized_fit",
  75753: "fit_guide_boxy_oversized_fit",
};

const fitGuideFitTypeIds = Object.keys(fitTypeIdToTranslationKey).map(Number);

type FitGuideEligibilityParams = {
  brandId?: number | null;
  productTypeId?: number | null;
  gender?: string | null;
  fitTypeId?: number | null;
  fitGuideUrl?: string | null;
};

export function isFitGuideEligible({
  brandId,
  productTypeId,
  gender,
  fitTypeId,
  fitGuideUrl,
}: FitGuideEligibilityParams): boolean {
  if (!fitGuideUrl) return false;

  if (
    brandId === null ||
    brandId === undefined ||
    productTypeId === null ||
    productTypeId === undefined ||
    gender === null ||
    gender === undefined ||
    fitTypeId === null ||
    fitTypeId === undefined
  ) {
    return false;
  }

  return (
    FIT_GUIDE_BRAND_IDS.includes(brandId) &&
    FIT_GUIDE_PRODUCT_TYPE_IDS.includes(productTypeId) &&
    FIT_GUIDE_GENDERS.includes(gender.toLowerCase()) &&
    fitGuideFitTypeIds.includes(fitTypeId)
  );
}
